import { useEffect } from 'react';

import { useAppSelector } from '@/Application/Hooks/Redux';
import {
  useGtmBillingProduct,
  useSendProductsBillingGtm
} from '@/modules/perseo-billing/hooks';

const useGtmEvents = () => {
  const { activeAccordion } = useAppSelector((state) => state.billing);
  const { accordionPaymentMethodId } = activeAccordion ?? {};
  const { sendPaymentSelectionGtm } = useGtmBillingProduct();

  useSendProductsBillingGtm(); // * use to send the products to GTM

  useEffect(() => {
    if (accordionPaymentMethodId) {
      sendPaymentSelectionGtm(accordionPaymentMethodId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accordionPaymentMethodId]);
};
export default useGtmEvents;
